import * as React from 'react';

export interface HighightedPropertyDetailsProps {
  propertyDetails?: string;
}

export const HighightedPropertyDetails: React.FunctionComponent<HighightedPropertyDetailsProps> = ({ propertyDetails }) => {
  if (!propertyDetails) {
    return null;
  }

  return (
    <div
      className="listing__highlighted-detail uitk-type-regular pwa-theme--grey-700 truncate uitk-type-300"
      data-stid="content-hotel-highlighted-detail"
    >
      {propertyDetails}
    </div>
  );
};
HighightedPropertyDetails.displayName = 'HighightedPropertyDetails';
